<template>
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 7C0 4.79086 1.79086 3 4 3H11.6319C13.147 3 14.5321 3.85601 15.2096 5.21115L20.1041 15L28.8083 31.0974C30.2494 33.7625 28.3196 37 25.2898 37H4C1.79086 37 0 35.2091 0 33V7Z"
      fill="#2C719C"
    />
    <path
      d="M0 13C0 10.7909 1.79086 9 4 9H30C32.2091 9 34 10.7909 34 13V33C34 35.2091 32.2091 37 30 37H4C1.79086 37 0 35.2091 0 33V13Z"
      fill="#2C719C"
    />
    <path
      d="M0 15C0 12.7909 1.79086 11 4 11H30C32.2091 11 34 12.7909 34 15V32C34 34.2091 32.2091 36 30 36H4C1.79086 36 0 34.2091 0 32V15Z"
      fill="#1E577B"
    />
    <path
      d="M0 16C0 13.7909 1.79086 12 4 12H30C32.2091 12 34 13.7909 34 16V33C34 35.2091 32.2091 37 30 37H4C1.79086 37 0 35.2091 0 33V16Z"
      fill="#3C89B9"
    />
  </svg>
</template>
